export class LocalStorageUtils {
  static setItem(key: string, item: any): void {
    localStorage.setItem(key, item);
  }
  static getItem(key: string): any {
    return JSON.stringify(localStorage.getItem(key) as any);
  }
  static removeItem(key: string): void {
    localStorage.removeItem(key);
  }
  static clearItems(): void {
    localStorage.clear();
  }
}
